<!-- HERO SECTION -->
<section class="wb-hero">
  <video autoplay muted loop playsinline class="wb-hero__video">
    <source src="assets/images/webinar.mp4" type="video/mp4" />
  </video>
  <div class="wb-hero__overlay"></div>
  <div class="wb-hero__content">
    <div class="wb-hero__badge">
      <span class="wb-hero__badge-dot"></span>
      LIVE &amp; FREE
    </div>
    <h1 class="wb-hero__title">Expert Webinars</h1>
    <h2 class="wb-hero__subtitle">11+ &amp; GCSE Mastery</h2>
    <p class="wb-hero__boards">
      CSSE &nbsp;|&nbsp; FSCE &nbsp;|&nbsp; GL &nbsp;|&nbsp; SET &nbsp;|&nbsp;
      ISEB &nbsp;|&nbsp; AQA &nbsp;|&nbsp; OCR &nbsp;|&nbsp; EDEXCEL &nbsp;|&nbsp;
      EDUQAS &nbsp;|&nbsp; A LEVEL
    </p>
    <div class="wb-hero__actions">
      <button class="wb-btn wb-btn--gold" (click)="openCalendar()">
        View All Events
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
      </button>
      <a class="wb-btn wb-btn--outline" href="https://www.sehyog.co.uk/freedemo" target="_blank">Book Free Demo</a>
    </div>
  </div>
  <div class="wb-hero__stats">
    <div class="wb-hero__stat">
      <span class="wb-hero__stat-num">10K+</span>
      <span class="wb-hero__stat-label">Students</span>
    </div>
    <div class="wb-hero__stat-divider"></div>
    <div class="wb-hero__stat">
      <span class="wb-hero__stat-num">Every Weekend</span>
      <span class="wb-hero__stat-label">Schedule</span>
    </div>
    <div class="wb-hero__stat-divider"></div>
    <div class="wb-hero__stat">
      <span class="wb-hero__stat-num">100%</span>
      <span class="wb-hero__stat-label">Free</span>
    </div>
    <div class="wb-hero__stat-divider"></div>
    <div class="wb-hero__stat">
      <span class="wb-hero__stat-num">7:00 PM</span>
      <span class="wb-hero__stat-label">BST</span>
    </div>
  </div>
</section>

<!-- ALERT STRIP -->
<div class="wb-strip">
  <div class="wb-strip__inner">
    <div class="wb-strip__left">
      <span class="wb-strip__icon">🔔</span>
      <div>
        <strong>LIMITED SEATS!</strong>
        <span>&nbsp;— Unlock Your Educational Excellence</span>
      </div>
    </div>
    <button class="wb-btn wb-btn--gold wb-btn--sm" (click)="openCalendar()">Book Your Seat Now</button>
  </div>
</div>

<!-- UPCOMING WEBINARS -->
<section class="wb-events">
  <div class="wb-events__header">
    <span class="wb-section-tag">Schedule</span>
    <h2 class="wb-section-title">Upcoming Webinars</h2>
    <p class="wb-section-sub">Join our expert-led sessions — completely free, every weekend</p>
  </div>

  <div class="wb-events__list">

    <!-- Card 1 -->
    <article class="wb-event-card">
      <div class="wb-event-card__img-wrap">
        <img src="assets/images/webinar-1.png" alt="Python Adventures Webinar" />
        <span class="wb-event-card__tag">GCSE</span>
      </div>
      <div class="wb-event-card__body">
        <div class="wb-event-card__meta">
          <span class="wb-event-card__date">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            13/08/2025 – 31/08/2025
          </span>
          <span class="wb-event-card__time">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            07:00 PM BST
          </span>
        </div>
        <h3 class="wb-event-card__title">Python Adventures</h3>
        <p class="wb-event-card__desc">Make coding your superpower and boost your Computer Science skills! Perfect for GCSE Computer Science revision &amp; beginners. Delivered live via Zoom.</p>
        <button class="wb-btn wb-btn--teal"
          onclick="window.open('https://www.sehyog.co.uk/11plus-help-club/category/workshop/2eed5585ff7658ea58c7bce6d2bfa7ce','_blank')">
          Register Free
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </button>
      </div>
    </article>

    <!-- Card 2 -->
    <article class="wb-event-card">
      <div class="wb-event-card__img-wrap">
        <img src="assets/images/webinar-2.png" alt="GCSE Admissions Webinar" />
        <span class="wb-event-card__tag">GCSE</span>
      </div>
      <div class="wb-event-card__body">
        <div class="wb-event-card__meta">
          <span class="wb-event-card__date">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            15/08/2025 – 26/08/2025
          </span>
          <span class="wb-event-card__time">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            07:00 PM BST
          </span>
        </div>
        <h3 class="wb-event-card__title">GCSE Admissions 2025</h3>
        <p class="wb-event-card__desc">Explore. Engage. Enrol — discover everything you need to know about GCSE Admissions 2025 in one live, free session with our expert advisors.</p>
        <button class="wb-btn wb-btn--teal"
          onclick="window.open('https://www.sehyog.co.uk/11plus-help-club/category/workshop/2eed5585ff7658ea58c7bce6d2bfa7ce','_blank')">
          Register Free
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </button>
      </div>
    </article>

    <!-- Card 3 -->
    <article class="wb-event-card">
      <div class="wb-event-card__img-wrap">
        <img src="assets/images/webinar-3.png" alt="11+ Breakthrough Webinar" />
        <span class="wb-event-card__tag wb-event-card__tag--gold">11+</span>
      </div>
      <div class="wb-event-card__body">
        <div class="wb-event-card__meta">
          <span class="wb-event-card__date">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            15/08/2025 – 29/08/2025
          </span>
          <span class="wb-event-card__time">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            07:00 PM BST
          </span>
        </div>
        <h3 class="wb-event-card__title">Your Child's 11+ Breakthrough</h3>
        <p class="wb-event-card__desc">From Curious to Confident — turn curiosity into capability. Discover proven 11+ tips and expert guidance in this powerful free online session.</p>
        <button class="wb-btn wb-btn--teal"
          onclick="window.open('https://www.sehyog.co.uk/11plus-help-club/category/workshop/5c70cc85bd7fe003b51ab9caa1173d4b','_blank')">
          Register Free
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </button>
      </div>
    </article>

  </div>
</section>

<!-- WHY ATTEND -->
<section class="wb-why">
  <div class="wb-why__header">
    <span class="wb-section-tag">Benefits</span>
    <h2 class="wb-section-title">Why Attend This Webinar?</h2>
    <p class="wb-section-sub">Everything you need to give your child the competitive edge</p>
  </div>

  <div class="wb-why__grid">

    <div class="wb-why__card">
      <div class="wb-why__card-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
      </div>
      <img src="assets/images/ch-2.jpg" alt="Broad Based Focus" class="wb-why__card-img" />
      <h4>Broad Based Focus</h4>
      <p>AQA &nbsp;|&nbsp; OCR &nbsp;|&nbsp; EDEXCEL &nbsp;|&nbsp; CSSE &nbsp;|&nbsp; FSCE &nbsp;|&nbsp; GL</p>
    </div>

    <div class="wb-why__card wb-why__card--featured">
      <div class="wb-why__card-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
      </div>
      <img src="assets/images/ch-3.jpg" alt="Valuable Tips" class="wb-why__card-img" />
      <h4>Valuable Tips</h4>
      <p>Top proven tips for GCSE &amp; 11+ success from experienced educators</p>
    </div>

    <div class="wb-why__card">
      <div class="wb-why__card-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
      </div>
      <img src="assets/images/ch-1.jpg" alt="Support and Guidance" class="wb-why__card-img" />
      <h4>Support &amp; Guidance</h4>
      <p>Mistakes to avoid, parent support guidance, and personalised advice</p>
    </div>

  </div>
</section>

<!-- ABOUT SEHYOG -->
<section class="wb-about">
  <div class="wb-about__inner">
    <div class="wb-about__left">
      <span class="wb-section-tag wb-section-tag--light">About Us</span>
      <h2 class="wb-about__title">Sehyog Academy</h2>
      <p class="wb-about__desc">
        Providing comprehensive support to <strong>11+, GCSE, AS/A Level</strong> students
        since over a decade in the <strong>United Kingdom</strong>.
      </p>
      <p class="wb-about__desc">Rated No. 1 in UK — now also in UAE.</p>
      <div class="wb-about__chips">
        <span class="wb-chip">11+ Preparation</span>
        <span class="wb-chip">GCSE Coaching</span>
        <span class="wb-chip">AS/A Level</span>
        <span class="wb-chip">Mock Tests</span>
      </div>
      <button class="wb-btn wb-btn--gold wb-btn--lg" (click)="openCalendar()">
        Book Your Seat Now
      </button>
    </div>
    <div class="wb-about__right">
      <img src="assets/images/lg-cir.png" alt="Sehyog Academy" class="wb-about__img" />
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="wb-testimonials">
  <div class="wb-testimonials__header">
    <span class="wb-section-tag">Success Stories</span>
    <h2 class="wb-section-title">Join 10,000+ Successful Students</h2>
    <p class="wb-section-sub">Trusted by parents and students across the UK</p>
  </div>

  <div class="wb-testimonials__grid">

    <div class="wb-tcard">
      <div class="wb-tcard__quote">"</div>
      <p class="wb-tcard__text">
        My son did Sehyog Mock Test — it's very helpful to know which areas my son is lacking.
        Sehyog result analysis gives us understanding on which area to improve and concentrate on,
        which is very important in the 11+ journey.
      </p>
      <div class="wb-tcard__author">
        <div class="wb-tcard__avatar">JR</div>
        <div>
          <strong>Jaya Rani</strong>
          <span>Parent</span>
        </div>
      </div>
    </div>

    <div class="wb-testimonials__video">
      <iframe
        src="https://www.youtube.com/embed/3PjPMOdyV-A"
        title="Happy Parents Speak: Success Stories 01"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
    </div>

    <div class="wb-testimonials__video">
      <iframe
        src="https://www.youtube.com/embed/fVU0xDgiclA"
        title="Happy Parents Speak: Success Stories 02"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
    </div>

    <div class="wb-tcard">
      <div class="wb-tcard__quote">"</div>
      <p class="wb-tcard__text">
        My son attended the mock exams by 11plushelpclub and it helped us a lot.
        With detailed results every week, we knew which area to work on. Topic-wise tests
        were a great form of revision. Big thanks to the entire team!
      </p>
      <div class="wb-tcard__author">
        <div class="wb-tcard__avatar">MD</div>
        <div>
          <strong>Mini Dagar</strong>
          <span>Parent</span>
        </div>
      </div>
    </div>

  </div>
</section>

<!-- CTA BANNER -->
<section class="wb-cta-banner">
  <div class="wb-cta-banner__inner">
    <h2>With Our Proven Methodology and Years of Experience</h2>
    <p>We help your child succeed in their <strong>11+, GCSE, AS/A Level</strong> journey</p>
    <button class="wb-btn wb-btn--gold wb-btn--lg" (click)="openCalendar()">
      Book Your Seat Now
    </button>
  </div>
</section>

<!-- FAQ -->
<section class="wb-faq">
  <div class="wb-faq__header">
    <span class="wb-section-tag">Help</span>
    <h2 class="wb-section-title">Frequently Asked Questions</h2>
  </div>

  <div class="wb-faq__list">

    <details class="wb-faq__item">
      <summary class="wb-faq__summary">
        I booked a session but haven't received confirmation yet?
        <span class="wb-faq__chevron">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
        </span>
      </summary>
      <div class="wb-faq__body">
        <p>Confirmation is sent automatically — please check your inbox or junk folder.</p>
        <p><strong>Classroom Exams:</strong> Download the Hall Ticket from your SEHYOG account. Login → Click Actions (eye icon) → Click Download or Email.</p>
        <p><strong>Online Exams:</strong> Go to sehyog.co.uk → My Student → Online Exam → Click TEST to attempt or SCORE to review results.</p>
      </div>
    </details>

    <details class="wb-faq__item">
      <summary class="wb-faq__summary">
        How do I book a SEHYOG session?
        <span class="wb-faq__chevron">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
        </span>
      </summary>
      <div class="wb-faq__body">
        <p>It's a simple 3-step process: (1) Go to sehyog.co.uk and create an account. (2) Verify via email and log in. (3) Add your student, go to the session listing page, and book your chosen session.</p>
      </div>
    </details>

    <details class="wb-faq__item">
      <summary class="wb-faq__summary">
        How do I join the Sehyog Telegram group for live support?
        <span class="wb-faq__chevron">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
        </span>
      </summary>
      <div class="wb-faq__body">
        <p>Join via this link: <a href="https://t.me/joinchat/SMnbMp4LZ9eEsm3h" target="_blank">https://t.me/joinchat/SMnbMp4LZ9eEsm3h</a></p>
      </div>
    </details>

  </div>

  <div class="wb-faq__contact">
    <p>Still have questions? Connect directly:</p>
    <div class="wb-faq__contact-links">
      <a href="tel:+447464772331" class="wb-contact-chip">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.44 2 2 0 0 1 3.59 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 6.53 6.53l1.62-1.62a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
        +44 7464 772331
      </a>
      <a href="mailto:academy@sehyog.co.uk" class="wb-contact-chip">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
        academy&#64;sehyog.co.uk
      </a>
    </div>
    <div class="wb-faq__social">
      <img src="assets/images/linkedin.png" alt="LinkedIn" />
      <img src="assets/images/facebook.png" alt="Facebook" />
      <img src="assets/images/youtube.png" alt="YouTube" />
      <img src="assets/images/twitter.png" alt="Twitter" />
      <img src="assets/images/instagram.png" alt="Instagram" />
    </div>
  </div>

  <p class="wb-disclaimer">
    SEHYOG is an educational institute dedicated to providing comprehensive support to KS2, 11+, KS3, GCSE &amp; A-Level students. Sessions and webinars conducted by SEHYOG do not guarantee 100% success in real exams. No claim is made as to the accuracy or authenticity of the content. SEHYOG or its volunteers/staff do not accept any liability for information provided in sessions, emails or social media.
  </p>
</section>

<!-- CALENDAR MODAL -->
<div class="wb-modal" *ngIf="showCalendar" [@fadeInOut]="modalState">
  <div class="wb-modal__backdrop" (click)="closeCalendar()"></div>
  <div class="wb-modal__content">
    <button class="wb-modal__close" (click)="closeCalendar()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
    <div class="wb-modal__header">
      <h2>Webinar Calendar 2025</h2>
      <p>Select a date below and click Book Now</p>
    </div>

    <div class="wb-modal__tabs">
      <button
        class="wb-modal__tab"
        [class.wb-modal__tab--active]="activeTab === 'past'"
        (click)="setActiveTab('past')">Past</button>
      <button
        class="wb-modal__tab"
        [class.wb-modal__tab--active]="activeTab === 'upcoming'"
        (click)="setActiveTab('upcoming')">Upcoming</button>
    </div>

    <div class="wb-modal__cards">
      <div class="wb-modal__card" *ngFor="let event of filteredEvents">
        <div class="wb-modal__card-date">{{ event.date }}</div>
        <div class="wb-modal__card-body">
          <h3>{{ event.title }}</h3>
          <p>Time: {{ event.time }}</p>
          <a class="wb-btn wb-btn--teal wb-btn--sm" href="{{ event.link }}" target="_blank">Book Now</a>
        </div>
      </div>
      <div class="wb-modal__empty" *ngIf="filteredEvents.length === 0">
        <p>No {{ activeTab }} events at the moment.</p>
      </div>
    </div>
  </div>
</div>